import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Image from "../Image/Image";
import parseHTML from "../../helpers/parseHTML";
import slugify from "../../helpers/slugify";
import { GlobalContext } from "../../context/GlobalContext";

function Card({
  blogId,
  image,
  title,
  text,
  author,
  releaseDate,
  category,
  data,
  search,
  additionalFunction,
}) {
  const { isMobile } = React.useContext(GlobalContext);

  return (
    <div className={`${isMobile ? "col-12" : "col-lg-6"}`}>
      <div className="card">
        {image && (
          <Link
            to={`/${category}/${blogId}/${slugify(title)}`}
            onClick={() => additionalFunction && additionalFunction()}
            data-toggle={search && "modal"}
            data-target={search && "#searchModal"}
          >
            <Image
              width={480}
              height={isMobile || search ? 180 : 240}
              className="card-img-top card-image"
              source={image}
              alternativetext="Card image cap"
            />
          </Link>
        )}
        <div className="card-body">
          <h4
            className="card-title card-title-selfmade text-truncate text-left text-dark"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={title}
          >
            <Link
              className="text-dark"
              to={`/${category}/${blogId}/${title}`}
              onClick={() => additionalFunction && additionalFunction()}
              data-toggle={search && "modal"}
              data-target={search && "#searchModal"}
            >
              {title}
            </Link>
          </h4>

          <p className="card-overflow text-left">{parseHTML(text, data)}</p>
          <p className="text-left">
            <small className="text-muted">{`${author} | ${moment(
              releaseDate
            )?.format("DD.MM.YYYY")}`}</small>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Card;
